import { AllArticleData, ArticleSet, TravelPersonalizedMarketingArticlesProps } from '../types/PersonalizedMarketingArticles';

export const isAd = (data: AllArticleData)
  : boolean => ('placementId' in data) || ('placementName' in data && 'channelName' in data);
export const isOffer = (data: AllArticleData)
  : boolean => 'offerText' in data && 'program' in data && 'hotelHref' in data;
export const isExploreMore = (data: AllArticleData)
  : boolean => data.id === 'exploreMore' && 'icon' in data && 'body' in data && 'ctaDestination' in data && 'ctaLabel' in data;

// eslint-disable-next-line complexity -- required for validation
const isValidArticleType = (data: AllArticleData): boolean => {
  if (!data || !data?.id) return false;

  // default article card
  if ('title' in data && 'body' in data && ('imageUrl' in data || 'fallbackImageUrl' in data)) {
    return !(!data.title || !data.body || (!data.imageUrl && !data.fallbackImageUrl));
  }

  // hotel offer card
  if ('offerText' in data && 'program' in data && 'hotelHref' in data) {
    return !(!data.program || !data.title || !data.offerText || !data.hotelHref);
  }

  // ad card
  if ('placementId' in data || ('placementName' in data && 'channelName' in data)) {
    return !(!data.placementId && (!data.placementName || !data.channelName));
  }

  return false;
};

export const filterArticles = (articles: TravelPersonalizedMarketingArticlesProps['articles']): ArticleSet => {
  if (!Array.isArray(articles) || !articles || articles.length === 0) return [];

  if ('name' in articles[0] && 'articles' in articles[0]) {
    const filters = articles as { name: string; articles: AllArticleData[] }[];
    return filters.map((filter) => {
      if (filter?.name && filter?.articles) {
        return {
          name: filter.name,
          articles: filter.articles?.filter(isValidArticleType),
        };
      }
      return null;
    }).filter((filter) => filter !== null) as { name: string; articles: AllArticleData[] }[];
  }

  return [{
    name: 'default',
    articles: (articles as AllArticleData[])?.filter((article) => isValidArticleType(article)),
  }];
};

type TagSet = {
  index: number;
  categoryName: string;
}[]

export const getTags = (articles: ArticleSet): TagSet => articles?.map((article, index) => ({
  index,
  categoryName: article.name,
}));

export const getActiveArticles = (
  articles: ArticleSet,
  activeTagIndex: number
): AllArticleData[] => articles?.[activeTagIndex]?.articles;
